import Vue from 'vue'
import Router from 'vue-router'
import SetPassword from '@/components/SetPassword'
import SetPassRoute from '@/components/SetPassRoute'
import ResetPassRoute from '@/components/ResetPassRoute'
import Welcome from '@/components/Welcome'
import ForgotPassword from '@/components/ForgotPassword'
import InvalidLink from '@/components/InvalidLink'
import WholeRoute from '@/components/WholeRoute'
import SuccessfullyUpdated from '@/components/SuccessfullyUpdated'

Vue.use(Router)
const router = new Router({
  mode: 'hash',
  //mode: 'history',
  routes: [
    {
      path: '*',
      component: InvalidLink
    },
    {
      path: '/activate',
      component: WholeRoute,
      children: [
        {
          path: '',
          name: 'ActivateInvalid',
          component: WholeRoute,
        },
        {
          path: 'forgotPassword',
          component: ResetPassRoute,
          children: [
            {
              path: '',
              name: 'ResetPasswordInvalid',
              component: ResetPassRoute,
            },
            {
              path: ':id',
              props: true,
              name: 'ForgotPassword',
              component: ForgotPassword
            },
          ]
        },
          {
          path: 'setPassword',
          component: SetPassRoute,
          children: [
            {
              path: '',
              name: 'SetPasswordInvalid',
              component: SetPassRoute,
            },
            {
              path: ':id',
              props: true,
              name: 'SetPassword',
              component: SetPassword
            }
          ]
        },
      ]
    },
    {
      path: '/invalidLink',
      name: 'InvalidLink',
      component: InvalidLink
    },
    
    {
        path: '/welcome',
        name: 'Welcome',
        component: Welcome
    },
    {
      path: '/success',
      name: 'Success',
      component: SuccessfullyUpdated
  },
  ]
})
export default router